import './bootstrap';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { AuthProvider, useAuth } from './lib/auth';
import AppShell from './AppShell';
import Landing from './pages/Landing';
import Login from './pages/Login';
import B2CLogin from './pages/B2CLogin';
import Dashboard from './pages/Dashboard';
import AdminOrganizations from './pages/AdminOrganizations';
import AdminAsteVinte from './pages/AdminAsteVinte';
import MatchInbox from './pages/MatchInbox';
import LeadPage from './pages/LeadPage';
import ImmobiliPage from './pages/ImmobiliPage';
import ImmobileDetail from './pages/ImmobileDetail';
import Mappa from './pages/Mappa';
import ProspectHome from './pages/ProspectHome';
import ProspectAnalyzed from './pages/ProspectAnalyzed';
import ProspectProfile from './pages/ProspectProfile';
import Trattative from './pages/Trattative';
import Agent from './pages/Agent';
import Impostazioni from './pages/Impostazioni';
import ProgettiShell, { VOCI_PROGETTI } from './pages/progetti/ProgettiShell';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          color: 'var(--fg-muted)',
          fontFamily: 'Geist, sans-serif',
          fontSize: 14,
        }}
      >
        Caricamento…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

// Chi ha il ruolo «progetti» ha un'applicazione sua e non vede mai l'AppShell
// (il server, comunque, gli chiude le API delle aste: SoloProgetti).
function ShellPerRuolo() {
  const { user } = useAuth();
  return user?.is_progetti ? <ProgettiShell /> : <AppShell />;
}

function Root() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/b2c" element={<B2CLogin />} />
          <Route
            path="/app"
            element={
              <RequireAuth>
                <ShellPerRuolo />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="match" element={<MatchInbox />} />
            <Route path="lead" element={<LeadPage />} />
            <Route path="lead-getrix" element={<Navigate to="/app/lead?source=getrix" replace />} />
            <Route path="immobili" element={<ImmobiliPage />} />
            <Route path="immobili/:id" element={<ImmobileDetail />} />
            <Route path="home" element={<ProspectHome />} />
            <Route path="analizzati" element={<ProspectAnalyzed />} />
            <Route path="profilo" element={<ProspectProfile />} />
            <Route path="mappa" element={<Mappa />} />
            <Route path="trattative" element={<Trattative />} />
            <Route path="agent" element={<Agent />} />
            <Route path="admin/organizations" element={<AdminOrganizations />} />
            <Route path="admin/aste-vinte" element={<AdminAsteVinte />} />
            <Route path="impostazioni" element={<Impostazioni />} />
            {/* Pagine dei progetti: per gli altri ruoli rimandano alla dashboard. */}
            {VOCI_PROGETTI.map((v) => (
              <Route key={v.path} path={v.path} element={<Navigate to="/app/dashboard" replace />} />
            ))}
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Root />
  </StrictMode>
);
